import React from "react";

const Text5 = () => {

  React.useEffect(() => {
    // 👇️ scroll to top on page load, behavior can be snappy with 'auto'
    document.getElementById('top')?.scrollIntoView({ behavior: 'smooth' });}
    , []);
    return(
      <>
        <p className="content-heading" id="top">
        Så här gör du   
      </p>
  
      <div className="content-text mt-4">
        <p>
          Börja med att välja fliken År 1. Med år menas här <i>verksamhetsår</i>, alltså 12 månader, valfritt startdatum. 
          För varje valt år visas <i>live</i> bedömd månadslön - efter skatter och avgifter - som din utbudsmix tillåter 
          dig ta ut - det året.                
        </p>
        <p>
          Välj sedan <i>direkt</i> vilken företagsform du vill bedriva valt år, då företagsformen påverkar kalkylen för 
          din månadslön. Du kan - när som helst - byta företagsform för valt år, för att testa vilken företagsform
          som blir lönsammast.          
        </p>
        <p>
          För att förstå vilka erbjudanden du vill <i>prioritera</i> skriver du nu in data för ditt utbud - en rad per 
          erbjudande. 
        </p>
        <p>
          Det står dig fritt att planera tre år framåt - eller färre år om du önskar. Behöver du därefter konsultera 
          <i> din</i>BiZ är det bara att starta en ny (treårs-)period. 
        </p>
        <p>
          Du väljer år i fri ordning men rekommenderas inleda med År 1  
        </p>
        <p><span className="strong">Obs!!! Glöm inte att spara dina data innan du avslutar.</span></p>

        <p className="heading2 mt-4">
          Utbudsmix/Erbjudanden 
        </p>
        <p>
          <i>(OBS priser och kostnader exklusive moms!)</i>
        </p>
        <ol>
          <li> Affärs-/produktområde fyller du i om det är meningsfullt för dig. </li>
          <li className="mt-2"> 
            Erbjudande kan innefatta en eller flera varor och/eller tjänster, allt efter vad som passar 
            dina behov. 
          </li>
          <li className="mt-2">
            <span className="strong">Försäljningspris</span> till kund som du bedömmer kan uppnås - efter rabatter 
            (och extra rabatter …). 
          </li>
          <li className="mt-2">
            <span className="strong">Rörliga kostnader</span> som sänker produktslagets lönsamhet - från material till 
            distribution och provision till agenter. <br/>
            <ul className="mt-2">
              <li>
                Försäljningspris minus <i>rörliga</i> kostnader kallas <span className="strong">täckningsbidrag</span>, 
                alltså med vilket belopp varje <i>försäljning</i> bidrar till att täcka fasta kostnader.
              </li>
              <li className="mt-1">
                Till höger därom visas produktens lönsamheten som <span className="strong">täckningsgrad</span>. 
                Alltså täckningsbidragets del - i procent - av varje intjänad krona. 
              </li>
            </ul>
            <p className="mt-2">
              Du ser nu direkt vilka produkter som är lönsammast. Både per enhet och per krona. 
            </p> 
          </li>
          <li className="mt-2">
            Debiterar du kunden i timmar anger du <span className="strong">arbetad tid i timmar</span> - eller del 
            av timme - som det tar dig från start till utförd leverans. Till höger visas då produktens 
            <span className="strong"> täckningsbidrag</span> per <i>arbetad</i> timme. <br/>

            För att få reda på vad affären faktiskt kostar dig att leverera räknar du även in den tid som <i>inte </i> 
            kan debiteras din  kund, exempelvis nedlagda timmar/resurser i förberedelser. 
          </li>
          <li className="mt-2">
            Det <span className="strong">antal enheter</span> av varje produktslag som du klarar av att leverera och 
            fakturera det analys-året. <br/>
            
            Nu visas produktslagets <i>volymvärden</i> för året längst till höger -  <span className="strong">årsförsäljning </span> 
            samt summerat <span className="strong">års-täckningsbidrag</span> för erbjudandet. 
          </li>
          <li className="mt-2">
            I summeringar på Dashboard i övre delen av skärmen visas bland annat Årstäckningsbidrag, alltså företagets samlade 
            <span className="strong"> täckningsbidrag</span> för att täcka firmans fasta kostnader - inklusive din lön 
            - och att räcka även till överskott/vinst. 
          </li>
        </ol>      
        <p>
          <span className="strong">Samtliga Utbuds-data kan kopieras från valfritt år till valfritt år. </span>
        </p>

        <p className="heading2 mt-4">
          Fasta Kostnader 
        </p>
        <p>
          Rörliga kostnader, som material och personal för tillverkning hanteras per erbjudande i Utbudsmixern. Men verksamheter 
          har även <i>fasta</i> kostnader som lön till anställda, lokalhyra, telefon, försäkring, bokföring/revision. 
        </p>
        <p>
          Välj Fasta Kostnader och ange varje fast kostnad som du förstår kommer att <i>behöva</i> tas. Kontrollera med lathunden 
          till vänster att du fått med nödvändiga rubriker. Det går fint att fylla på och komplettera både data och rubriker 
          efter hand. 
        </p>
        <p>
          Som du ser påverkas din månadslön negativt av varje kostnad du för in. Med <i>lägre</i> fasta kostnader visas alltså
          <i> högre</i> månadslön. För högre månadslön bör du tänka igenom vilka kostnader som kan <i>vänta, smetas ut</i> över tid 
          (som med leasing) eller rent av elimineras. 
        </p> 
        <p>
          Dock finns även ”goda” kostnader - som ökar din försäljning. De kan vara värda att tas och finansieras genom att hålla 
          igen på resten. Bränd startkassa är en mycket vanlig konkursorsak. Förstå vilka kostnader som är goda och sträva att 
          skära bort/ner resten. 
        </p>
        <p>
          Räknar du med att ha <span className="strong">antälld(a)</span>, skriver du in dessa lönekostnader <i>samt </i> 
          arbetsgivaravgifter i Fasta Kostnader. Din egen eventuella lön hanteras automatiskt och kan justeras/anpassas 
          individuellt under menyvalet Lönekalkyl.           
        </p>
        <p>
          <span className="strong">Samtliga FastaKostnader-data kan kopieras från valfritt år till valfritt år - inklusive 
          rubriker.</span>
        </p>

        <p className="heading2 mt-4">
          Åtgärder 
        </p>
        <p>
          Du kan fylla på med rader och fältinnehåll efterhand. Exempelvis lägga upp fem åtgärder med bara arbetsnamn och 
          sedan fylla i åtgärdernas respektive fält när du bestämt dig. 
          <ol>
            <li className="mt-2">
              Skriv in ett arbetsnamn för din planerade åtgärd. Namnet kan ändras vid behov.
            </li>
            <li className="mt-2">
              Prioritet kan anges från ”1” till ”3” och du bestämmer själv ifall ”1” eller ”3” anger din högsta prioritet. 
              Klicka i fältet för att ändra åtgärdens prioritet.  
            </li>
            <li className="mt-2">
              Klicka på den del av planerad <i>startdatum</i> för åtgärden som du vill ändra och klicka på det datum i 
              kalendern som ska gälla. 
            </li>
            <li className="mt-2">
              Klicka på den del av planerat <i>klartdatum</i> för åtgärden som du vill ändra och klicka på det datum i 
              kalendern som ska gälla. 
            </li>
            <li className="mt-2">
              Efter hand som du fyller i planerad tidsåtgång per åtgärd och år ser du i fältet ”Total” den ackumulerade 
              arbetstiden för åtgärden för respektive år, samt - i dashboard överst i display - summan av alla  
              åtgärdstimmar för alla planerade åtgärder per år. Och i ”Samtliga Åtgärdstimmar” visas summan av samtliga 
              planerade arbetstimmar för <i>alla</i> åtgärder under <i>alla</i> tre åren.            
              (Vedertagen svensk norm för arbetstid är 1750 årstimmar.) <br/>Du kan ange vilket antal 
              årstimmar du vill när du åtgärdsplanerar. Skulle normen överskridas signalerar <i>din</i>BiZ, så att du kan 
              välja grad av utbrändhet som kan accepteras på vägen mot mål.
            </li>
            <li className="mt-2">
              Efter hand som du fyller i bedömd kostnad per åtgärd och år ser du i fältet ”Total” dina ackumulerade kostnader 
              för åtgärden för respektive år, samt - i dashboard överst i display - summan av alla bedömda kostnader för alla 
              planerade åtgärder per år. Och i ”Samtliga Åtgärdskostnader” visas summan av samtliga planerade arbetstimmar 
              från alla åtgärder för alla tre åren. 
            </li>
          </ol>
        </p>
        <p>
          Åtgärder sorteras default i registreringsordning och du kan välja att istället visa dem sorterade på annat valfritt fält.
        </p>

        <p className="heading2 mt-4">
          Lönekalkyl 
        </p>
        <p>
          Fältet Månadslön (netto) visar <i>inte</i> ditt exakta löneutrymme utan ett rimligt närmevärde, baserat på 
          schablon-skattesats. 
        </p>
        <p>
          För en mera individuellt anpassad beräkning väljer du Lönekalkyl och justerar skattedata efter dina personliga 
          förutsättningar. 
        </p>
        <p>
          Löneberäkningen för AB är baserad på antagandet att man tar ut hela överskottet i företaget som lön och därför har 
          inte någon företagsskatt beräknats.
        </p>
        <p>
          Såklart visas inte eventuella övriga skattepliktiga inkomster - och avdrag - från <i>annan</i> inkomst utanför 
          <i>din</i>BiZ-kalkylen.
        </p>
        
      </div>
    </>
  );
}
export default Text5;